import { persistedEnumAtom } from '@/core/state';
import { StorageKey } from '@/core/storage';

export type Basemap = 'default' | 'satellite';

export const basemapAtom = persistedEnumAtom<Basemap>(
  StorageKey.Basemap,
  ['default', 'satellite'],
  'satellite',
);
